import $ from "jquery";

window.$ = window.jQuery = $;

$( document ).ready(
	function () {
		let $modals = $( '.modals' );

		/**
		 * Find the modal, terminate it
		 */
		function closeModal() {
			$( "body" ).removeClass( "modal-open" );
			$( ".modal.open" ).remove();
		}

		/**
		 * Put an image in a modal
		 *
		 * @param $teaser
		 */
		function openModal( $teaser = {} ) {
			const template = $( "template.image-modal-template" ).html();
			let $modal     = $( template ).clone();

			$modal.find( "figure img" ).attr( "src", $teaser.data( "url" ) );
			$modal.find( "figure figcaption" ).html( $teaser.data( "caption" ) );

			$( "body" ).append( $modal ).addClass( "modal-open" );

			$modal.addClass( 'open' );

			$modal.on(
				"click touch",
				function ( e ) {
					closeModal();
				}
			);
		}

		/**
		 * Initialize modals.
		 */
		$( document ).ready(
			function () {
				if ( $modals.length > 0 ) {
					$( ".modal-trigger", $modals ).on(
						"click touch",
						function ( e ) {
							e.stopPropagation();
							let $this = $( e.target );
							openModal( $this );
						}
					);
				}
			}
		);
	}
);
